import React, { useCallback } from "react";
import styled from "styled-components";
import Button from "components/Button";
import Icon from "react-icons-kit";
import { ic_delete_sweep } from "react-icons-kit/md/ic_delete_sweep";
import { clearEntityIds } from "state/selections/actions";
import { useDispatch } from "react-redux";

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const HeaderRenderer = (props) => {
  const dispatch = useDispatch();
  const onButtonClick = useCallback(() => {
    dispatch(clearEntityIds());
  }, [dispatch]);
  return (
    <Root>
      <Button
        size={"S"}
        onButtonClick={onButtonClick}
        icon={<Icon icon={ic_delete_sweep} size={18} />}
        variation={0}
        tooltip={"Remove all entities"}
      />
    </Root>
  );
};

export default HeaderRenderer;
